import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { PerModal } from '../../../../../components/custom_components/Modal'
import PerSpacer from '../../../../../components/custom_components/Spacer'

interface MeetingModalProps {
  title: string
  visible: boolean
  confirmDisabled?: boolean
  confirmText?: string
  tooltip?: string
  submittingCloseMeeting?: boolean
  onCancel: () => void
  onConfirm: () => void
}

const MeetingModal: FC<MeetingModalProps> = ({
  title,
  visible,
  confirmDisabled,
  confirmText,
  tooltip,
  submittingCloseMeeting,
  onCancel,
  onConfirm,
  children,
}) => {
  const [t] = useTranslation()

  let confirmBtnText
  if (confirmText) {
    confirmBtnText = { altText: confirmText }
  } else {
    confirmBtnText = { text: 'confirm' }
  }

  return (
    <PerModal
      title={{ heading: title }}
      size="small"
      centered
      visible={visible}
      onCancel={onCancel}
      footer={{
        cancelBtn: {
          text: t('global.button.edit'),
          onClick: onCancel,
          icon: 'edit_fill',
        },
        confirmBtn: {
          ...confirmBtnText,
          onClick: onConfirm,
          disabled: !!confirmDisabled,
          tooltip: tooltip,
          isProcessing: { active: !!submittingCloseMeeting },
        },
      }}
    >
      {children}

      <PerSpacer mt="s" />
    </PerModal>
  )
}
export { MeetingModal }
